import { Divider } from "@mantine/core";

// Labels one of the lists on the workspace members page, with its size, so
// "no pending invitations" and "four members" read without counting rows.
export function SectionLabel({ title, count }) {
  const label = count === undefined ? title : `${title} · ${count}`;

  return <Divider my="md" label={label} labelPosition="left" />;
}
